module.exports = __webpack_public_path__ + "img/sad-icon.ec2a649.svg";